module.exports = __webpack_public_path__ + "img/logo-long.d9b7b745.png";